import i18next from 'i18next';

interface WhatHappensNowType {
  content: string[];
}

const WhatHappensNow = () => {
  const WhatHappensNow: WhatHappensNowType = {
    content: i18next.t('summary.whatHappensNow.body', { returnObjects: true }),
  };

  return `
    <div class="waykevaluation-stack waykevaluation-stack--4">
      <h4 class="waykevaluation-heading waykevaluation-heading--4">
        ${i18next.t('summary.whatHappensNow.heading')}
      </h4>
      <div class="waykevaluation-content">
        ${WhatHappensNow.content
          .map((c) => `<p class="waykevaluation-content__p">${c}</p>`)
          .join('')}
      </div>
    </div>
  `;
};

export default WhatHappensNow;
